export enum PaymentCycle {
	Monthly,
	OneOff
}